import React, { FC } from 'react';
import cls from 'classnames';

import { NavToggle } from 'src/shoppe/elements/NavToggle';

import styles from './index.module.sass';

interface MobileMenuToggleProps {
  className?: string;
  isActive: boolean;
  onClick: () => void;
}

const MobileMenuToggle: FC<MobileMenuToggleProps> = ({ className, isActive, onClick }) => (
  <NavToggle
    className={{ container: cls( styles.button, className ) }}
    isActive={isActive}
    onClick={onClick}
  />
);

export default MobileMenuToggle;
